export default [
    {
        path: '/hr/overtimes',
        name: 'overtimes',
        props: true,
        component: () => import('@/views/hr/overtimes/index.vue'),
        meta: {
            pageTitle: 'Overtimes',
            breadcrumb: [
                {
                text: 'Overtimes',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/overtimes/:id',
        name: 'detail-overtimes',
        props: true,
        component: () => import('@/views/hr/overtimes/detail.vue'),
        meta: {
            pageTitle: 'Detail Overtime',
            breadcrumb: [
                {
                text: 'Overtimes',
                to: { name: 'overtimes' },
                },
                {
                text: 'Detail Overtime',
                active: true,
                },
            ],
        },
    },
]